import request from '@/utils/request'

export function fetchSlotList(params) {
  return request({
    url:'sms_slot/list/',
    method:'get',
    params:params
  })
}

export function fetchSlotHistoryList(params,code) {
  return request({
    url:'/sms_slot/history/'+ code,
    method:'get',
    params:params
  })
}


export function createSlot(data) {
  return request({
    url:'/sms_slot/create',
    method:'post',
    data:data
  })
}

export function updateSlot(id, data) {
  return request({
    url:'/sms_slot/update/' + id,
    method:'post',
    data:data
  })
}

export function deleteSlot(id) {
  return request({
    url:'/sms_slot/delete/'+ id,
    method:'delete',
  })
}

